import script from "./SuggestedAddress.vue?vue&type=script&setup=true&lang=ts"
export * from "./SuggestedAddress.vue?vue&type=script&setup=true&lang=ts"

import "./SuggestedAddress.vue?vue&type=style&index=0&id=62477e35&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62477e35"]])

export default __exports__